export default "__VITE_ASSET__B$9Mz3Su__"